module.exports = __webpack_public_path__ + "img/solution-data-advantage3.87a7a689.svg";